import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { GameProvider } from "@/context/GameContext";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { LatencyProbeProvider } from "@/context/LatencyContext";
import ServerBrowser from "@/pages/ServerBrowser";
import ServerPage from "@/pages/ServerPage";
import DowntimePage from "@/pages/DowntimePage";
import TrendsPage from "@/pages/TrendsPage";
import RankingsPage from "@/pages/RankingsPage";
import AuthCallback from "@/pages/AuthCallback";
import RootErrorBoundary from "@/components/RootErrorBoundary";
import { useGA4PageTracking } from "@/lib/analytics";

const AppRouter = () => {
  const location = useLocation();
  useGA4PageTracking();
  // Detect auth callback by fragment (synchronous — must happen before ProtectedRoute)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<ServerBrowser />} />
      <Route path="/server/:id" element={<ServerPage />} />
      <Route path="/server/:id/downtime" element={<DowntimePage />} />
      <Route path="/trends" element={<TrendsPage />} />
      <Route path="/trends/:gameId" element={<TrendsPage />} />
      <Route path="/rankings" element={<RankingsPage />} />
      <Route path="/rankings/:gameId" element={<RankingsPage />} />
      <Route path="*" element={<ServerBrowser />} />
    </Routes>
  );
};

function App() {
  return (
    <RootErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <GameProvider>
            <FavoritesProvider>
              <LatencyProbeProvider>
                <div className="App">
                  <BrowserRouter>
                    <AppRouter />
                  </BrowserRouter>
                  <Toaster
                    position="bottom-right"
                    theme="dark"
                    toastOptions={{
                      style: {
                        background: "var(--bg-elevated)",
                        border: "1px solid var(--primary-accent)",
                        color: "var(--text-primary)",
                        fontFamily: "var(--font-mono)",
                        borderRadius: 2,
                      },
                    }}
                  />
                </div>
              </LatencyProbeProvider>
            </FavoritesProvider>
          </GameProvider>
        </AuthProvider>
      </ThemeProvider>
    </RootErrorBoundary>
  );
}

export default App;
